/*
 * @Author: Zhouqi
 * @Date: 2025-10-31 16:08:43
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-10-31 16:44:22
 */
type UserIconProps = {
  className?: string;
};

export const UserIcon = ({ className }: UserIconProps) => {
  return (
    <div
      className={`flex justify-center items-center rounded-full bg-app-card border border-app w-[30px] h-[30px] ${className}`}
    >
      <svg
        width="11"
        height="14"
        viewBox="0 0 11 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.45833 0C3.27221 0 1.5 1.77221 1.5 3.95833C1.5 6.14446 3.27221 7.91667 5.45833 7.91667C7.64446 7.91667 9.41667 6.14446 9.41667 3.95833C9.41667 1.77221 7.64446 0 5.45833 0ZM2.75 3.95833C2.75 2.46256 3.96256 1.25 5.45833 1.25C6.9541 1.25 8.16667 2.46256 8.16667 3.95833C8.16667 5.4541 6.9541 6.66667 5.45833 6.66667C3.96256 6.66667 2.75 5.4541 2.75 3.95833Z"
          fill="#fff"
        />
        <path
          d="M2.95833 9.4938C0.984737 9.4938 0.163508 10.9382 0.0224847 12.8275C-0.00320829 13.1718 0.279822 13.4521 0.625 13.4521C0.970178 13.4521 1.2458 13.1717 1.26637 12.8272C1.33767 11.6327 1.67767 10.7438 2.95833 10.7438H7.95833C9.239 10.7438 9.57899 11.6327 9.6503 12.8272C9.67086 13.1717 9.94649 13.4521 10.2917 13.4521C10.6368 13.4521 10.9199 13.1718 10.8942 12.8275C10.7532 10.9382 9.93193 9.4938 7.95833 9.4938H2.95833Z"
          fill="#fff"
        />
      </svg>
    </div>
  );
};
